import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes, faTrash } from '@fortawesome/free-solid-svg-icons'
import { InteractionType } from '../../types/communication/communicationDataType'
import { FileFullPageImage, FileFullPageImageContainer, FullPageCloseBtn, FullPageDeleteBtn } from '../styled/File.style';
import { useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { tqPageView } from '../../utils/utils';
import linearTrashBinGreen from '../../assets/img/linear_trashbin_green.svg';
import linearClose from '../../assets/img/linear_close.svg';

interface FileImgFullPageCmpProps {
    file: InteractionType;
    close: any
    deleteHandler?: any;
    companyName?: string
}

const FileImgFullPageCmp = ({ file, close, deleteHandler, companyName }: FileImgFullPageCmpProps) => {
    let { token } = useParams();
    let previewURL = `${window.REACT_APP_VTV_API_ENDPOINT}/api/realtime/communication/${token}/download-attachment/${file._id}`;

    useEffect(() => {
        // Analytics
        tqPageView('cai:foto evento:foto')
    }, [])

    return (
        <>
            <FileFullPageImageContainer>
                {deleteHandler && <FullPageDeleteBtn onClick={deleteHandler} >
                    {companyName === "LINEAR" ? <img
                        src={linearTrashBinGreen}
                        alt="TrashBin"
                        style={{ width: "40px" }}
                    /> : <FontAwesomeIcon icon={faTrash} />}
                </FullPageDeleteBtn>}

                <FileFullPageImage src={previewURL} alt="Foto contesto full page" />
                <FullPageCloseBtn onClick={close} >
                    {companyName === "LINEAR" ? <img
                        src={linearClose}
                        alt="Close"
                        style={{ width: "40px", color: "white" }}
                    /> : <FontAwesomeIcon icon={faTimes} />}
                </FullPageCloseBtn>
            </FileFullPageImageContainer>
        </>
    )
}

export default FileImgFullPageCmp
